export const chatSliceName = "chat";